import React from 'react'
import ReactDOM from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import { Router } from './router'
import './index.css'
import { PlatformProvider } from './contexts/PlatformContext'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <HelmetProvider>
      <PlatformProvider>
        <Router />
      </PlatformProvider>
    </HelmetProvider>
  </React.StrictMode>,
)
